import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ConnectionService } from '../connection/connection.service';
import { UploadModel } from 'src/models/upload.model';

@Injectable({
  providedIn: 'root',
})
export class NfsSendService {
  constructor(private conn: ConnectionService) {}

  public async send(form: FormData) {
    const res = await this.conn.post(`${environment.URL_SERVER}/upload`, form);
    return res;
  }
  public async resend(table: string) {
    const res = await this.conn.post(`${environment.URL_SERVER}/resend`, {
      table: table,
    });
    return res;
  }

  public async downloadErrors(table: string, not_sended: boolean = false) {
    const url = not_sended
      ? `${environment.URL_SERVER}/download/errors?notsended=true`
      : `${environment.URL_SERVER}/download/errors`;
    const res = await this.conn.post(
      url,
      {
        table: table,
      },
      null,
      'arraybuffer',
    );
    return res;
  }
}
